import React, { useState, useEffect } from 'react'
import toast, { Toaster } from 'react-hot-toast';
import { initNotifications, onMessageListener } from '../../services/firebase/firebase';
import logo from '../../assets/images/pentalens-loader.png'

const PushNotification = () => {
  const [notification, setNotification] = useState({ title: '', body: '' });

  useEffect(() => {
    initNotifications();
  }, []);

  useEffect(() => {
   
    const unsubscribe = onMessageListener().then(payload => {
     
      const newNotification = {
        title: payload?.notification?.title,
        body: payload?.notification?.body,
      };

      setNotification(newNotification);

      toast(
        <div style={{ display: 'flex', alignItems: 'center', padding: '12px', minWidth: '300px', justifyContent: 'space-between', borderRadius: '8px'}}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src={logo} alt="Logo" style={{ width: '40px', height: '40px', marginRight: '10px' }} />
            <div>
            <strong style={{ fontSize: '18px' }} dangerouslySetInnerHTML={{ __html: newNotification?.title }} />
            <p style={{ fontSize: '14px', margin: '4px 0 0' }} dangerouslySetInnerHTML={{ __html: newNotification?.body }} />
            </div>
          </div>
          <div style={{ cursor: 'pointer', marginLeft: '16px', fontSize: '20px' }} onClick={() => toast.dismiss()}>
            &times;
          </div>
        </div>,
        {
          duration: 60000,
          position: "top-right",
        }
      );

    });
    return () => {
      unsubscribe.catch(err => console.log("failed: ", err));
    };
  }, [notification]);

  return (
    <div>
      <Toaster />
    </div>
  )
}

export default PushNotification